// extracted by mini-css-extract-plugin
export var defaultWrapper = "_n7-3";
export var downloadButton = "_n7-4";
export var fileContainer = "_n7-9 _n7-7";
export var fileContainerBase = "_n7-7";
export var fileContainerFixedHeight = "_n7-8 _n7-7";
export var fileInfo = "_n7-5";
export var fileInfoWidthRestricted = "_n7-6";
export var fileType = "_n7-1";
export var fileTypeName = "_n7-2";
export var image = "_n7-0";
export var link = "_n7-b";
export var overflowEllipsis = "_n7-a";